/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Styled components for LabelsImport Final step
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.3.0
 */

import styled from 'styled-components';

import { colors, fonts } from '@theme/index';

export const LabelsImportInfoBlockContainerStyled = styled.div`
    margin: 16px 0;
    display: inline;
`;

export const LabelsImportExportErrorButtonContainerStyled = styled.div`
    margin-right: 16px;
`;

export const LabelsImportValidationStatusContainerStyled = styled.div`
    width: 387px;
    box-sizing: border-box;
    padding: 16px;
    border: 1px solid ${colors.labelsImportValidationStatusBorder};
    border-radius: 4px;
    margin-top: 24px;
`;

export const LabelsImportValidationStatusFileContainerStyled = styled.div`
    display: flex;
    align-items: center;
`;

export const LabelsImportValidationStatusFileMessageStyled = styled.div`
    display: inline-block;
    white-space: nowrap;
`;

export const LabelsImportValidationStatusFileNameStyled = styled.span`
    ${fonts.textMainBold};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface ILabelsImportValidationStatusProgressBarStyled {
    percent: number;
}

export const LabelsImportValidationStatusProgressBarStyled = styled.div<ILabelsImportValidationStatusProgressBarStyled>`
    height: 8px;
    width: 100%;
    border-radius: 4px;
    background: ${props => `linear-gradient(to right, ${colors.labelsImportValidationStatusProgressBarSuccess}
    ${props.percent}% , ${colors.labelsImportValidationStatusProgressBarWaiting} ${props.percent}%)`};
    margin: 8px 0 16px;
`;

export const LabelsImportValidationStatusInfoItemStyled = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
`;

export const LabelsImportValidationStatusLinkContainerStyled = styled.div`
    margin-top: 12px;
`;

export const LabelsImportValidationStatusLoaderContainerStyled = styled.div`
    margin-top: 24px;
`;
